import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-carousel-home',
  templateUrl: './carousel-home.component.html',
  styleUrls: ['./carousel-home.component.scss']
})
export class CarouselHomeComponent implements OnInit {

  @Input() lista: any[];

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {}

  truncateHTML(item: any, charlimit: number): string {
    var text = item?.Descricao;
    if (!text || text.length <= charlimit) {
      return text;
    }
    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + "...";
    return shortened;
  }

  limitarCaracteresTitulo(item: any, charlimit: number): string {
    var text = item;
    if (!text || text.length <= charlimit) {
      return text;
    }
    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + "...";
    return shortened;
  }

  getimagembyUrl(url: string): string {
    return environment.baseUrl + "/rest/file/getImg/v2?url=" + url.split("pef/")[1];
  }

  redirectnoticia(noticia: any){
    var text = noticia?.Categoria;
    if(text=="Educacao Financeira"){
      this.router.navigateByUrl('/noticias-e-eventos/educacao-financeira/detalhe/'+noticia.ID);
    }else if(text=="Inclusao Financeira"){
      //this.router.navigateByUrl('/banco/pesquisa/');
      this.router.navigateByUrl('/noticias-e-eventos/inclusao-financeira/detalhe/'+noticia.ID);
    }
  }

}
